import React from 'react';
import { Stack, TabPanel } from '@chakra-ui/react';
import PillarConfigRow from '../../Questionnaires/PillarConfigRow';
import SaveButtonCertification from '../../../pages/researches/Certification/SaveButton';

export const PillarConfigList = ({
 control,
 setValue,
 isDirty,
 fields,
 handlePillarsConfig,
 showNumberOfThemes = false,
 showNumberOfLevels = false,
 children,
}) => {
 const handleSave = () => {
  handlePillarsConfig();
 };

 return (
  <TabPanel p='6'>
   {children}
   <Stack spacing={6} mt='6'>
    {fields.map((field, index) => (
     <PillarConfigRow
      key={field.id}
      index={index}
      control={control}
      register={control.register}
      setValue={setValue}
      field={field}
      showNumberOfThemes={showNumberOfThemes}
      showNumberOfLevels={showNumberOfLevels}
     />
    ))}

    <SaveButtonCertification
     control={control}
     isDirty={isDirty}
     onSave={handleSave}
     validateThemes={showNumberOfThemes}
     validateLevels={showNumberOfLevels}
    />
   </Stack>
  </TabPanel>
 );
};
